import { render, staticRenderFns } from "./activity-tax-certificates.vue?vue&type=template&id=c7e79252&scoped=true&"
import script from "./activity-tax-certificates.vue?vue&type=script&lang=ts&"
export * from "./activity-tax-certificates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e79252",
  null
  
)

export default component.exports